<template>
  <div class="inline-block relative w-full | input-group">
    <label
      v-if="label"
      :for="id"
      :class="[error ? labelError : labelValid]"
      class="w-full cursor-pointer text-sm pl-1"
    >{{ label }}</label>
    <multiselect
      :value="value"
      :options="options"
      @input="input"
      :id="id"
      :multiple="multiple"
      :close-on-select="!multiple"
      :track-by="trackBy"
      :label="optionLabel"
      :group-label="groupLabel"
      :group-values="groupValues"
      :class="error ? 'has-error' : ''"
    ></multiselect>
    <p v-if="info && !error" class="text-sm text-blue mt-1 pl-1">{{ info }}</p>
    <p v-if="error" class="text-sm text-red-8 mt-1 pl-1">{{ error }}</p>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"

export default {
  name: "Select",
  components: { Multiselect },
  props: {
    value: {
      required: true
    },
    options: {
      required: true
    },
    id: {
      required: true
    },
    errors: {
      default: null
    },
    label: {
      default: null
    },
    info: {
      default: null
    },
    multiple: {
      default: false
    },
    trackBy: {
      default: null
    },
    optionLabel: {
      default: null
    },
    groupLabel: {
      default: null
    },
    groupValues: {
      default: null
    }
  },
  data() {
    return {
      labelValid: "text-blue-8",
      labelError: "text-red-8"
    }
  },
  computed: {
    error() {
      if (!this.errors) return false
      return this.errors.has(this.id) ? this.errors.first(this.id) : false
    }
  },
  methods: {
    input(val) {
      if (this.errors) this.errors.clear(this.id)
      this.$emit("input", val)
    }
  }
}
</script>
